export enum AppRouter {
  Main = "/",
  Gallery = "/gallery",
  MyGames = "/mygames",
  Constructor = "/mygames/:gameId",
  Login = "/login",
  Game = "/gallery/:gameId",
  Settings = "/settings",
  Secret = "/stepakogdavofrank",
  NotFoundPage = "*",
}
